import {
  CartActionTypes,
  ICartSetCardIdAction,
  ICartAddExperienceAction,
  ICartEditItemAction,
  ICartPersistExperiencesAction,
  ICartRemoveExperienceAction,
  ICartResetAction,
  ICartNoNeedToLoadPersistedCartItemsAction,
  ICartSetCartLoadingAction,
  CartAction,
} from 'types/cart';
import isCartItemExpired from 'utils/cart/isCartItemExpired';

export const setCartId = (
  payload: ICartSetCardIdAction['payload'],
): ICartSetCardIdAction => ({
  type: CartActionTypes.SET_CART_ID,
  payload,
});

export const addExperienceToCart = (
  payload: ICartAddExperienceAction['payload'],
): ICartAddExperienceAction => ({
  type: CartActionTypes.ADD_EXPERIENCE_TO_CART,
  payload,
});

export const addExperienceToCartThunk = (
  payload: ICartAddExperienceAction['payload'],
) => {
  return async (dispatch: (action: CartAction) => void): Promise<string> => {
    const metadata = payload.cartItemMetadata;
    const isExpired = isCartItemExpired(metadata);
    if (isExpired) {
      return 'EXPIRED';
    }

    dispatch(addExperienceToCart(payload));

    // Wait for next tick to ensure reducer has processed
    await new Promise((resolve) => {
      setTimeout(resolve, 0);
    });

    dispatch(setCartLoading({ loading: false }));
    return payload.cartItemId;
  };
};

export const editCartExperience = (
  payload: ICartEditItemAction['payload'],
): ICartEditItemAction => ({
  type: CartActionTypes.EDIT_CART_ITEM,
  payload,
});

export const editCartExperienceThunk = (
  payload: ICartEditItemAction['payload'],
) => {
  return async (dispatch: (action: CartAction) => void): Promise<string> => {
    dispatch(editCartExperience(payload));

    // Wait for next tick to ensure reducer has processed
    await new Promise((resolve) => {
      setTimeout(resolve, 0);
    });
    dispatch(setCartLoading({ loading: false }));

    return payload.cartItemId;
  };
};

export const setCartLoading = (
  payload: ICartSetCartLoadingAction['payload'],
): ICartSetCartLoadingAction => ({
  type: CartActionTypes.SET_CART_LOADING,
  payload,
});

export const loadPersistedCartItems = (
  payload: ICartPersistExperiencesAction['payload'],
): ICartPersistExperiencesAction => ({
  type: CartActionTypes.LOAD_PERSISTED_CART_ITEMS,
  payload,
});

export const noNeedToLoadPersistedCartItems =
  (): ICartNoNeedToLoadPersistedCartItemsAction => ({
    type: CartActionTypes.NO_NEED_TO_LOAD_PERSISTED_CART_ITEMS,
    payload: undefined,
  });

export const removeExperienceFromCart = (
  payload: ICartRemoveExperienceAction['payload'],
): ICartRemoveExperienceAction => ({
  type: CartActionTypes.REMOVE_EXPERIENCE_FROM_CART,
  payload,
});

export const resetCart = (brandId: string): ICartResetAction => ({
  type: CartActionTypes.RESET_CART,
  payload: {
    persistMeta: {
      brandId,
    },
  },
});
